var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherSettingsBcba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2868 5.30462C14.5308 5.19305 14.6873 4.94152 14.6845 4.66511C14.6818 4.3887 14.5203 4.14058 14.2741 4.03426L8.55793 1.33594C8.20633 1.16973 7.80245 1.16973 7.45084 1.33594L1.73531 4.03149C1.49268 4.14162 1.33594 4.3901 1.33594 4.6646C1.33594 4.9391 1.49268 5.18759 1.73531 5.29771L7.45084 7.99879C7.80245 8.165 8.20633 8.165 8.55793 7.99879L14.2868 5.30462Z",
    stroke: "#0C66E4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 4.66406V8.66406",
    stroke: "#0C66E4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.32812V9.66043C4 10.7645 5.79086 11.6596 8 11.6596C10.2091 11.6596 12 10.7645 12 9.66043V7.32812",
    stroke: "#0C66E4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherSettingsBcba);
export default __webpack_public_path__ + "static/media/otherSettingsBcba.5442dbbe442883768bdded66088403be.svg";
export { ForwardRef as ReactComponent };